import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useMemo, useLayoutEffect, useEffect } from "react";
import { createGlobalStyle } from "styled-components";
import { useCookbookContext, CookbookContextProvider } from "@creditornot/cb-context";
import { semanticColors } from "@creditornot/cb-ingredients";
import { createCssVarDefinitions, SEMANTIC_CSS_VAR_PREFIX, DATA_ATTR_THEME, DATA_ATTR_HEADING_FONT, resolveHeadingFontByLocale } from "@creditornot/cb-utils";
const useIsomorphicLayoutEffect = typeof window === "object" ? useLayoutEffect : useEffect;
function prefixObjKeys(prefix, obj) {
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    newObj[`${prefix}-${key}`] = value;
  }
  return newObj;
}
const GlobalThemeStyles = createGlobalStyle`
  :root {
    ${createCssVarDefinitions(prefixObjKeys(SEMANTIC_CSS_VAR_PREFIX, semanticColors.light))}
  }

  [data-cb-theme='light'] {
    ${createCssVarDefinitions(prefixObjKeys(SEMANTIC_CSS_VAR_PREFIX, semanticColors.light))}
  }

  [data-cb-theme='lightHighContrast'] {
    ${createCssVarDefinitions(
  prefixObjKeys(SEMANTIC_CSS_VAR_PREFIX, semanticColors.lightHighContrast)
)}
  }

  [data-cb-theme='dark'] {
    ${createCssVarDefinitions(prefixObjKeys(SEMANTIC_CSS_VAR_PREFIX, semanticColors.dark))}
  }
`;
const useThemeMode = () => {
  const cookbookContext = useCookbookContext();
  return cookbookContext ? cookbookContext.themeMode : "light";
};
const useDirection = () => {
  const cookbookContext = useCookbookContext();
  return cookbookContext ? cookbookContext.direction : "ltr";
};
const CookbookProvider = ({
  children,
  direction = "ltr",
  locale = "en",
  themeMode = "light"
}) => {
  useIsomorphicLayoutEffect(() => {
    document.documentElement.setAttribute(DATA_ATTR_THEME, themeMode);
  }, [themeMode]);
  useIsomorphicLayoutEffect(() => {
    document.documentElement.setAttribute(
      DATA_ATTR_HEADING_FONT,
      resolveHeadingFontByLocale(locale)
    );
  }, [locale]);
  useIsomorphicLayoutEffect(() => {
    document.documentElement.setAttribute("dir", direction);
  }, [direction]);
  const contextValue = useMemo(
    () => ({
      direction,
      domain: "tools",
      themeMode
    }),
    [direction, themeMode]
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(GlobalThemeStyles, {}),
    /* @__PURE__ */ jsx(CookbookContextProvider, { value: contextValue, children })
  ] });
};
export {
  CookbookProvider,
  useDirection,
  useThemeMode
};
//# sourceMappingURL=index.js.map
